export function makeBubbleOptions(options) {
  return Object.assign({}, options, {
    bubble: { textStyle: { fontSize: 11 } },
    legend: { position: "right" },
    width: "100%",
    height: "400",
    chartArea: {
      left: 150,
      top: 30,
      bottom: 100,
    },
  });
}
